import React, { useState } from "react";

function SearchEvents({ onSearch, placeholder }) {
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  return (
    <div className="mb-4 w-full relative">
      <input
        type="text"
        value={searchTerm}
        onChange={handleChange}
        name="search"
        placeholder={placeholder}
        className="px-4 py-2 w-full border border-gray-300 rounded-md focus:outline-none"
      />
    </div>
  );
}

export default SearchEvents;
